import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import FormContainer from './FormContainer'
import imgLoading from '../../../images/loading.gif'
import Cookies from 'universal-cookie'
import '../../../FormGenericHooks.scss'
import '../App.css'
import { getBaseURL } from '../../../../GlobalComponents/URLs'
import { useParams } from 'react-router-dom'
import { savingAtom, saveTimeAtom, formDataAtom,  baseDataAtom } from '../../../State/Atoms/FormData/FormDataAtoms'
import {
    newFormIdAtom,
    newFormServiceTypeAtom,
    formTypeAtom,
    formIdAtom,
    recordIdAtom,
    recoveryIdAtom,
    formLoadedAtom,
    fieldChangedAtom,
    lockedLevelsAtom,
    recordLockLevelAtom
} from '../../../State/Atoms/FormProps/FormPropsAtoms'
import {
    assetServiceTypesAtom,
    assetTypesAtom,
    newFormAssetTypeAtom,
    assetCategoriesAtom,
} from '../../../State/Atoms/AssetData/AssetDataAtoms'
import { useRecoilState } from 'recoil'
import { prepareData, checkInValid } from './Helpers/DataHelpers'
import { sendLog } from '../../Logging/SendLog'
import { LoadingImage } from './LoadingImage'

var sendingLogs = 0
let renders = 0
const versionNumber = 4

//let saving = false
//let waitingToSave = false

export const FormGeneric = () => {
    const params = useParams() // Call useParams at the top level

    const match = useMemo(() => {
        return { params }
    }, [params])

    //const [coRoot, setcoRoot] = useState('')
    // const [autosaveId, setAutosaveId] = useState(-1);
    //const autosaveId = useRef(-1)
    // keeping the state since it's needed for renders but also want ref for events
    //const refRecordId = useRef(-1)
    //const lockInfo = useRef({})
    // const [lastAutosaveTime, setLastAutosaveTime] = useState(false)
    //const lastAutosaveTime = useRef(false)
    const [saving, setSaving] = useRecoilState(savingAtom)
    //const [saving2, setSaving2] = useState(false)
    const savingRef = useRef(saving)
    const [savedTime, setSavedTime] = useRecoilState(saveTimeAtom)
    const [formId, setFormId] = useRecoilState(formIdAtom)
    const formIdRef = useRef(formId)
    //const [formId, setFormId] = useState(-1)
    const [recordId, setRecordId] = useRecoilState(recordIdAtom)
    const recordIdRef = useRef(recordId)
    const [baseData, setBaseData]=useRecoilState(baseDataAtom)
    const baseDataRef = useRef(baseData)
    //const [recordId, setRecordId] = useState(-1)
    const [recoveryId, setRecoveryId] = useRecoilState(recoveryIdAtom)
    //const [recoveryId, setRecoveryId] = useState(-1)
    const [formType, setFormType] = useRecoilState(formTypeAtom)

    //const [formLoaded, setFormLoaded] = useState(false)
    const [formLoaded, setFormLoaded] = useRecoilState(formLoadedAtom)
    //const [fieldChanged, setFieldChanged] = useState(false)
    const [fieldChanged, setFieldChanged] = useRecoilState(fieldChangedAtom)
    const [disableSubmits, setDisableSubmits] = useState(false)
    const [myVersion, setMyVersion] = useState('')
    const [versionOutOfDate, setVersionOutOfDate] = useState(false)
    const [newFormCategory, setNewFormCategory] = useState('')
    const [assetCategories, setAssetCategories] = useRecoilState(assetCategoriesAtom)
    const [newFormAssetType, setNewFormAssetType] = useRecoilState(newFormAssetTypeAtom)
    const newFormAssetTypeRef = useRef(newFormAssetType)
    //setNewFormAssetType(match.params.customerAssetTypeID ? match.params.customerAssetTypeID : '')
    // const [newFormAssetType, setNewFormAssetType] = useState(() =>
    //     match.params.customerAssetTypeID ? match.params.customerAssetTypeID : ''
    // )
    const [assetTypes, setAssetTypes] = useRecoilState(assetTypesAtom)
    const [newFormServiceType, setNewFormServiceType] = useRecoilState(newFormServiceTypeAtom)
    const newFormServiceTypeRef = useRef(newFormServiceType)

    //setNewFormServiceType(match.params.serviceType ? match.params.serviceType : '')

    //const [assetServiceTypes, setAssetServiceTypes] = useState(false)
    const [assetServiceTypes, setAssetServiceTypes] = useRecoilState(assetServiceTypesAtom)
    const [newFormId, setNewFormId] = useRecoilState(newFormIdAtom)
    const [defaultData, setDefaultData] = useState([])
    //const [formData, setFormData] = useRecoilState(formDataAtom)

    const [data, setData] = useState([])
    const defaultDataRef = useRef([])
    const dataRef = useRef([])
    const [recordLockLevel, setRecordLockLevel] = useRecoilState(recordLockLevelAtom)
    const recordLockLevelRef = React.useRef(recordLockLevel)
    // const setRecordLockLevel = (newLevel) => {
    //     recordLockLevelRef.current = newLevel
    //     setRecordLockLevelUnused(newLevel)
    // }
    //const [lockedLevels, setLockedLevels] = useState('')
    const [lockedLevels, setLockedLevels] = useRecoilState(lockedLevelsAtom)
    const lockedLevelsRef = useRef(lockedLevels)
    const [locked, setLocked] = useState(false)
    const [updateInfo, setUpdateInfo] = useState(false)
    const [reload, setReload] = useState(false)
    const queueRef = useRef(null)
    const [lockOnSave, setLockOnSave] = useState(false)
    // const throttledHandleSubmit = useCallback(
    //     throttle((data) => handleSubmitWithData(data), 20000), // 20 seconds throttle
    //     []
    //   )
    const debouncedHandleSubmit = useCallback(
        debounce((data) => handleSubmitWithData(data), 10000), // Debounce for 1 second
        []
    )
    useEffect(() => {
        // insert parameters matched from url into state object
        // since only formid or recordid is passed in, but not both, the undefined param will be -1
        setFormId(match.params.formId ? match.params.formId : -1)
        setRecordId(match.params.recordId ? match.params.recordId : -1)
        setRecoveryId(match.params.recoveryId ? match.params.recoveryId : -1)
    }, [match])

    useEffect(() => {
        recordIdRef.current = recordId
        formIdRef.current = formId
        newFormServiceTypeRef.current = newFormServiceType
        newFormAssetTypeRef.current = newFormAssetType
        lockedLevelsRef.current = lockedLevels
        recordLockLevelRef.current = recordLockLevel
        baseDataRef.current = baseData
    }, [recordId, formId, newFormServiceType, newFormAssetType, lockedLevels, recordLockLevel, baseData])

    useEffect(() => {
        const formTypeFromParams = match.params.formType ? match.params.formType : ''
        setFormType(formTypeFromParams)
    }, [match.params.formType, setFormType])

    useEffect(() => {
        const formTypeFromParams = match.params.customerAssetTypeID
            ? match.params.customerAssetTypeID
            : ''
        setNewFormAssetType(formTypeFromParams)
    }, [match.params.customerAssetTypeID, setNewFormAssetType])

    useEffect(() => {
        const formTypeFromParams = match.params.serviceType ? match.params.serviceType : ''
        setNewFormServiceType(formTypeFromParams)
    }, [match.params.serviceType, setNewFormServiceType])

    const releaseLock = (recordId) => {
        let startedDate = new Date()
        let url = getBaseURL() + 'webapi/lock/ReleaseRecordLock/' + recordId
        fetch(url, {
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
            },
            keepalive: true,
            credentials: 'include',
        }).then((response) => {
            if (response.status === 200) {
            } else {
                let errorEntry = `Reason:Renew Lock Failed: ${response.status} 
                    Fetch submitted at ${startedDate} failed at ${new Date()}, 
                    EventName: JS Error: RenewLock,Description: 'Failed to RenewLock Version:' + versionNumber`
                sendLog(errorEntry)
            }
        })
    }

    useEffect(() => {
        // continuously checks asset-manifest.json to see that it matches the main.js version saved on init
        const checkVersionMatch = async () => {
            // use fetch to open and send asynchronous request for asset-manifest.json
            fetch(`${getBaseURL()}FormGeneric/asset-manifest.json`)
                .then((response) => {
                    if (response.ok) return response.json()

                    throw new Error(response.text())
                })
                .then((fileJson) => {
                    // convert responseText (json text) into JSON object for easy consumption
                    //const response = JSON.parse(fileJson);
                    // if state myVersion is blank save main.js filename in myVersion state variable
                    // if not blank and compiled version in file doesn't match version saved in state, set versionOutOfDate state variable
                    if (myVersion === '') setMyVersion(fileJson['files']['main.js'])
                    else if (myVersion !== fileJson['files']['main.js']) setVersionOutOfDate(true)
                })
        }

        if (
            document.location.hostname !== 'localhost' &&
            document.location.hostname !== '127.0.0.1'
        ) {
            checkVersionMatch()
            // save in state the current version of main.js being used in asset-manifest.json
            // only set myVersion on initial load to detect changes later
            setInterval(checkVersionMatch, 300000)
        }

        if (fieldChanged) {
            window.addEventListener('beforeunload', changeWarning)
            return () => {
                window.removeEventListener('beforeunload', changeWarning)
            }
        }
    }, [myVersion, fieldChanged])

    useEffect(() => {
        return () => debouncedHandleSubmit.cancel()
    }, [debouncedHandleSubmit])

    useEffect(() => {
        const handleUnload = () => {
          releaseLock(recordIdRef.current) // Call the release function when the user leaves
        }
    
        window.addEventListener('beforeunload', handleUnload)
    
        return () => {
          window.removeEventListener('beforeunload', handleUnload)
        }
    }, [releaseLock])

    const changeWarning = (ev) => {
        ev.preventDefault()
        return (ev.returnValue = 'There are unsaved changes. Are you sure you want to close?')
    }

    const shouldAutosave = (lastUpdate) => {
        return lastUpdate === false || lastUpdate > lastAutosaveTime.current
    }


    const isPerformanceReview = () => {
        if (data.Form && data.Form.length > 0) {
            if (data.Form[0].Purpose?.trim().toUpperCase() === 'PERFORMANCE REVIEW') {
                return true
            }
        } else {
            if (data.Form?.Purpose?.trim().toUpperCase() === 'PERFORMANCE REVIEW') {
                return true
            }
        }
        return false
    }

    const newRecord = (formId) => {
        setRecordId(-1)
        setFormId(formId)
        autosaveId.current = -1
        let formUrl = getBaseURL() + 'webapi/form/form/' + formId
        fetch(formUrl, {
            credentials: 'include',
        })
            .then((resp) => {
                if (resp.ok) return resp.json()
                else throw new Error('failed to fetch ' + formUrl)
            })
            .then((json) => {
                setDefaultData(json)
            })
    }
    // callback function invoked on successful form load
    // allows child component (FormContainer) to set state variable in parent (App)
    // passing lockLevel -- only set for autosavedForms
    const handleFormLoaded = (data, lockLevel) => {
        const formId = data.FormSectionFieldValueView[0].FormId
        // when only recordId is passed in through the url, FormContainer uses it to determine formId and passes it back up to App
        setFormId(formId)
        // setting formLoaded to true hides loading image and shows completed form
        setFormLoaded(true)
        // save default data for comparing when posting
        setDefaultData(JSON.parse(JSON.stringify(data)))
        defaultDataRef.current = JSON.parse(JSON.stringify(data))
        // save data for changing when updated by user
        setData(data)
        dataRef.current = JSON.parse(JSON.stringify(data))

        let newLockLevel
        // if passed use it, otherwise check formRecord
        if (lockLevel) newLockLevel = lockLevel
        else newLockLevel = data.FormRecord.length > 0 ? data.FormRecord[0].LockLevel : 0

        setRecordLockLevel(newLockLevel)
    }

    //const handleRecordLockLevelChange = (newLockLevel) => setRecordLockLevel(newLockLevel)

    // when user updates a field, change corresponding value in state for posting
    const handleFormFieldChange = (newData, changed = true) => {
        setData(newData)
        dataRef.current = JSON.parse(JSON.stringify(newData))
        changed && setFieldChanged(true)

        if (!isPerformanceReview()) {
            changed && !checkInValid(newData, recordLockLevel) && debouncedHandleSubmit(newData)
        }
    }

    const checkIfUnicode = (string) => {
        // matches nonascii
        let match = string.match(/[\u{0080}-\u{FFFF}]/gu, '')
        return match ? true : false
    }

    const canPrint = () => !fieldChanged
    const prepDelete = () => {
        window.removeEventListener('beforeunload', changeWarning)
    }

    // saves current form to database
    const handleSubmit = (e) => {
        setSaving(true)
        //waitingToSave = false
        // don't actually submit the form. going to POST the data below
        e.preventDefault()
        // immediately set state variable to disable save buttons - prevents multiple clicks/saves

        // using ref since app.jsx doesnt need these for rendering purposes but needs them to be updated during saves between renders for queued saves
        let saveData = dataRef.current
        prepareData(
            saveData,
            setDisableSubmits,
            setFieldChanged,
            setRecordId,
            defaultDataRef,
            newFormAssetTypeRef.current,
            newFormServiceTypeRef.current,
            recordLockLevelRef,
            lockedLevelsRef.current,
            recordIdRef.current,
            formIdRef.current,
            saving,
            defaultData,
            data,
            versionNumber,
            setSaving
        )
    }

    const handleSubmitWithData = async (data) => {
        if (savingRef.current || saving) return false
        setSaving(true)
        savingRef.current = true
        // using ref since app.jsx doesnt need these for rendering purposes but needs them to be updated during saves between renders for queued saves
        await prepareData(
            data,
            setDisableSubmits,
            setFieldChanged,
            setRecordId,
            baseDataRef,
            newFormAssetTypeRef.current,
            newFormServiceTypeRef.current,
            recordLockLevelRef.current,
            lockedLevelsRef.current,
            recordIdRef.current,
            formIdRef.current,
            saving,
            baseDataRef.current,
            data,
            versionNumber,
            setSaving,
            setSavedTime,
            savingRef,
            setBaseData
        )
        queueRef.current.flushEventQueue(recordIdRef.current)
    }

    const onAutosaveSuccess = (newId, lastUpdated) => {
        autosaveId.current = newId
        lastAutosaveTime.current = lastUpdated
    }

    renders += 1

    // let testDict1= {
    //     FormSectionFieldValueView: [
    //         {FormSectionFieldId: 1, StringFieldValue: 'a'},
    //         {FormSectionFieldId: 2, StringFieldValue: 'b'}
    //     ]
    // }

    // let testDict2= {
    //     FormSectionFieldValueView: [
    //         {FormSectionFieldId: 1, StringFieldValue: 'a'},
    //         {FormSectionFieldId: 2, StringFieldValue: 'a'}
    //     ]
    // }

    // let dif = diff(testDict1, testDict2)

    return (
        <div className='formGenericTheme'>
            <div className='formGenericContainer'>
                <form className='form-inline' onSubmit={handleSubmit}>
                    <div
                        style={{
                            display: formType === '' ? '' : 'none',
                            width: '100%',
                        }}
                    >
                        {!formLoaded && <LoadingImage imgLoading={imgLoading} />}

                        {/* if form is completely loaded show the form instead of the loading image */}
                        <div
                            style={{
                                display: formLoaded ? '' : 'none',
                            }}
                        >
                            {
                                <FormContainer
                                    formid={formId}
                                    recordid={recordId}
                                    recoveryId={recoveryId}
                                    disableSubmits={false} //not doing this anymore right now because autosaving
                                    defaultData={defaultData}
                                    setFormLoaded={setFormLoaded}
                                    onFormLoaded={handleFormLoaded}
                                    onFormFieldChange={handleFormFieldChange}
                                    //onRecordLockLevelChange={handleRecordLockLevelChange}
                                    showVersionOutOfDateAlert={versionOutOfDate}
                                    shouldAutosave={shouldAutosave}
                                    //onAutosaveLoad={handleAutosaveLoaded}
                                    //onAutosaveSuccess={onAutosaveSuccess}
                                    canPrint={canPrint}
                                    reload={reload}
                                    prepDelete={prepDelete}
                                    newRecord={newRecord}
                                    handleSubmit={handleSubmit} //needed for autocalls
                                    handleSubmitWithData={handleSubmitWithData}
                                    //refLockInfo={lockInfo}
                                    assetType={newFormAssetType}
                                    serviceType={newFormServiceType}
                                    setAssetType={setNewFormAssetType}
                                    setServiceType={setNewFormServiceType}
                                    updateInfo={updateInfo}
                                    locked={locked}
                                    // not ideal pending change --- needed for now though
                                    ref={queueRef}
                                />
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
